module.exports = __webpack_public_path__ + "assets/img/0b05-va.svg";